import { Params, useRequest } from "~/api/Request"
import API from "~/api/api"
import { FormDefault, ListUserFormat, UserFormat, FormDefaultDetail } from "~/model/Form"

export function useForms() {
  const { Request } = useRequest()
  const getDefaultForm = async () => {
    const res = await Request.get<FormDefault[]>(API.FORM_DEFAULT)
    return res
  }

  const getFormUserSelect = async (id: string) => {
    return await Request.get<any>(API.FORM_USER_SELECT.replace("{id}", id))
  }

  const getFormNormal = async (id: string) => {
    return await Request.get<FormDefaultDetail>(API.FORM_NORMAL.replace("{id}", id))
  }

  const postForm = async (id: string | string[], data: Params) => {
    return await Request.post(API.FORM_SAVE.replace("{id}", `${id}`), data)
  }

  const getFormUser = async (id: string | string[], params: Params = {}) => {
    return await Request.get<ListUserFormat>(API.FORM_USER.replace("{id}", `${id}`), params)
  }

  const checkLisenseForm = async (params: Params) => {
    return await Request.get<boolean>(API.CHECK_LISENSE, params)
  }

  const getFormUserInfo = async (userId: string | string[]) => {
    return await Request.get<UserFormat>(API.FORU_USER_INFO.replace("{userId}", `${userId}`))
  }

  return {
    getDefaultForm,
    getFormUserSelect,
    getFormNormal,
    postForm,
    getFormUser,
    getFormUserInfo,
    checkLisenseForm,
  }
}
